import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { toMoxyDateNullable, type MoxyDateString } from "~/common/types/MoxyDate";

export interface CreateContractRequest {
  contractNumber: string;
  quantity: number | null;
  numberOfDeliveries: number | null;
  materialNumber?: string;
  packageCode?: string;
  address: string;
  startDate: Date | null;
  endDate: Date | null;
  unloadingPoint: string | null;
  comment: string;
}

interface CreateContractRequestWsDTO extends Omit<CreateContractRequest, "startDate" | "endDate"> {
  startDate: MoxyDateString | null;
  endDate: MoxyDateString | null;
}

export function toCreateContractRequestWsDTO(request: CreateContractRequest): CreateContractRequestWsDTO {
  return {
    ...request,
    startDate: toMoxyDateNullable(request.startDate),
    endDate: toMoxyDateNullable(request.endDate),
  };
}

export function createContract(request: CreateContractRequest): Promise<Response> {
  return occFetch(occUrl("/contract/create"), {
    body: JSON.stringify(toCreateContractRequestWsDTO(request)),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });
}
